import styled, { css } from 'styled-components';

interface ButtonStylesProps {
  $variant: 'primary' | 'secondary' | 'tertiary' | 'primary-link' | 'secondary-link';
  $buttonSize: 's' | 'm' | 'l';
  $isHidden?: boolean;
  $isInlineLink?: boolean;
  $alignRight?: string;
}

export const ButtonStyles = styled.button<ButtonStylesProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  line-height: 1.449rem;
  font-weight: bold;
  margin: 0.625rem 0.063rem;
  height: ${(props) => (props.$buttonSize === 's' ? '1rem' : props.$buttonSize === 'm' ? '2.5rem' : '3rem')};
  padding: 0.688rem 1.375rem;
  border: 0.125rem solid ${(props) => props.theme.colors.primary};
  cursor: pointer;
  border-radius: 0.4rem;
  min-width: ${(props) => (props.$buttonSize === 's' ? '7rem' : props.$buttonSize === 'm' ? '11rem' : '14.688rem')};
  transition: all 0.3s ease;
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.25);

  ${(props) =>
    props.$variant === 'primary' &&
    css`
      background: ${(props) => props.theme.colors.bgSecondary};
      border: 0.125rem solid ${(props) => props.theme.colors.bgSecondary};
      color: ${(props) => props.theme.colors.bgWhite};
      &:hover {
        background: ${(props) => props.theme.colors.bgSecondary};
        border-color: ${(props) => props.theme.colors.bgSecondary};
        color: ${(props) => props.theme.colors.bgWhite};
        opacity: 0.8;
      }
    `}

  ${(props) =>
    props.$variant === 'secondary' &&
    css`
      flex-shrink: 0;
      border-radius: 0.438rem;
      border: 0.125rem solid ${(props) => props.theme.colors.primary};
      background: ${(props) => props.theme.colors.bgWhite};
      color: ${(props) => props.theme.colors.primary};
      &:hover {
        background: ${(props) => props.theme.colors.bgWhite};
        border-color: ${(props) => props.theme.colors.primary};
        color: ${(props) => props.theme.colors.primary};
        opacity: 0.8;
      }
    `}

  ${(props) =>
    props.$variant === 'tertiary' &&
    css`
      background: ${(props) => props.theme.colors.bgGrey};
      border: 0.125rem solid ${(props) => props.theme.colors.bgGrey};
      color: ${(props) => props.theme.colors.bgWhite};
      &:hover {
        background: ${(props) => props.theme.colors.bgGrey};
        border-color: ${(props) => props.theme.colors.bgGrey};
        color: ${(props) => props.theme.colors.bgWhite};
        opacity: 0.8;
      }
    `}
    ${(props) =>
    props.$variant === 'primary-link' &&
    css`
      background: transparent;
      border: none;
      padding: 0;
      display: inline-flex;
      width: fit-content;
      min-width: 0;
      height: auto;
      color: ${props.theme.colors.primary};
      cursor: pointer;
      box-shadow: none;
      justify-content: ${props.$alignRight ? 'flex-end' : 'center'};

      > span {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        text-decoration: none;
      }

      span.text {
        text-decoration: underline;
      }

      &:hover {
        color: ${props.theme.colors.primary};
        opacity: 0.7;
      }
    `}


  ${(props) =>
    props.$variant === 'secondary-link' &&
    css`
      background: transparent;
      border: none;
      padding: 0;
      color: ${props.theme.colors.bgWhite};
      text-decoration: underline;
      cursor: pointer;
      box-shadow: none;
      &:hover {
        text-decoration: underline;
        color: ${props.theme.colors.bgWhite};
        opacity: 0.7;
      }
    `}

  &:disabled {
    background: ${(props) => props.theme.colors.bgDisable};
    border: 0.125rem solid ${(props) => props.theme.colors.bgDisable};
    cursor: not-allowed;
    box-shadow: none;
    &:hover {
      transform: none;
      box-shadow: none;
      opacity: 1;
    }
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 2.5rem;
    min-width: 8rem;
    font-size: 0.75rem;
  }
`;

export const ButtonContainer = styled.nav<ButtonStylesProps>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  justify-content: ${({ $alignRight }) => ($alignRight ? $alignRight : 'center')};
  position: relative;
  width: 100%;
  height: ${(props) => (props.$buttonSize === 's' || props.$buttonSize === 'm' ? '4rem' : '4rem')};
  margin-bottom: ${({ $isInlineLink }) => ($isInlineLink ? '0rem' : '2rem')};
`;
